define(
    'views/notifications.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/jgrowl-notification-body.html',
        'text!templates/notifications-menu.html',
        'text!templates/notifications-profile-menu.html',
        'text!templates/notifications.html',
        'text!templates/topic_viewers.html'
    ],
    function(Loader, Config, Helper, Sandbox, template, templateMenu, templateProfileMenu, templateContent, topicViewersContent)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var NotificationsView = Loader.Backbone.View.extend(
            {
                isActive: false,
                items: [],
                settings: {},
                pageTitle: '',
                interval: 0,
                favicon: window.Favico ? new window.Favico({
                    animation:'slide'
                }) : null,

                topicInitialValues: {
                    topicIsOpen: !!$('#topic-users-in').html(),
                    currentTopicId: $('#pun-viewtopic').attr('data-topic-id')
                },

                events: {
                    'click .notify-message a': 'readNotice',
                    'click input[name=updateSettings]': 'updateSettings',
                    'click .jGrowl-close': 'closeMessage',
                    'click .jGrowl-closer': 'closeMessages'
                },

                routes: {
                    'profile.php[?]section=fields[&]id=(.*)[&]p=notifications': 'requestNotifications',
                    'profile.php': 'profileMenu'
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    var closeHandler = function(e) {
                        const id = +e.target.parentNode.attributes['data-id'].value;
                        if (id) {
                            Sandbox.transport.io.send('readNotify', {
                                nid: id
                            });
                        }
                    };

                    this.model.on('startApplication', function(){
                        if (Config.modules.notifications.enabled) {
                            Helper.filterRoutes(_this.routes, _this);
                            _this.renderMenu();
                        }
                        _this.pageTitle = document.title;
                    });

                    Sandbox.transport.io.subscribe('notify', function(data){
                        _this.notifications(data);
                        _.delay(function () {
                            // костыль, ну а че еще поделать
                            $('.jGrowl-close').off('click', closeHandler);
                            $('.jGrowl-close').on('click', closeHandler);
                        }, 500);
                    });

                    if (!this.model.get('users').getMe().isGuest()) {
                        Sandbox.transport.io.subscribe('newNoticesCount', function(data){
                            _this.updateCount(data);
                        });
                    }

                    Sandbox.transport.io.subscribe('notifications', function(data){
                        _this.items = data.reverse();
                        _this.renderContent();
                    });

                    Sandbox.transport.io.subscribe('notificationsSettings', function(data){
                        _this.settings = data;
                        _this.renderContent();
                    });

                    Sandbox.transport.io.subscribe('updateNotificationSettingsStatus', function(data){
                        data && location.reload();
                    });

                    Sandbox.transport.io.subscribe('read', function(id){
                        $('.jGrowl-notification[data-id="' + id + '"]').remove();
                    });

                    Sandbox.transport.io.subscribe('readAll', function(){
                        _this.items.forEach(function(item) {
                            $('.jGrowl-notification[data-id="' + item.id + '"]').remove();
                        });
                    });

                    Sandbox.transport.io.subscribe('readInTopic', function(topicId){
                        _this.items.forEach(function(item) {
                            if (item.params.topic_id == topicId) {
                                $('.jGrowl-notification[data-id="' + item.id + '"]').remove();
                            }
                        });
                    });

                    if (this.topicInitialValues.topicIsOpen && window['BoardID'] === 240846) {
                        this.prepareTopicViewers();
                    }
                    Sandbox.transport.io.subscribe('topic_viewers', function(data){
                        if (!(this.topicInitialValues.topicIsOpen && window['BoardID'] === 240846)) {
                            return;
                        }
                        if (this.topicInitialValues.currentTopicId != data.params.topicId) {
                            return;
                        }
                        if (data.user.id == 1) {
                            this.topicInitialValues.guestsCount = this.topicInitialValues.guestsCount + (data.isView ? 1 : -1);
                        } else {
                            this.topicInitialValues.users = _.filter(this.topicInitialValues.users, function(o) {
                                return o.id != data.user.id;
                            });
                            if (data.isView) {
                                this.topicInitialValues.users.push({
                                    id: data.user.id,
                                    username: data.user.username
                                });
                            }
                            this.topicInitialValues.usersCount = this.topicInitialValues.users.length;
                        }
                        this.renderTopicViewers();
                    }.bind(this));
                },

                render: function()
                {
                    return this;
                },

                notifications: function(data)
                {
                    var compiledTemplate = _.template(
                        template,
                        {
                            model: this.model.toJSON(),
                            data: data,
                            from: data.params.from_user,
                            Helper: Helper
                        }
                    );

                    $.jGrowl.defaults.position = 'bottom-right';
                    $.jGrowl(compiledTemplate, {
                        header: (data.header || 'Уведомление'),
                        theme: 'notify-message jg-'+data.type,
                        life: data.duration,
                        sticky: data.sticky,
                        id: data.id,
                        beforeOpen: function($e, m, o) {
                            $e.attr('data-id', data.id);
                        },
                        click: function($e, m, o) {
                            Sandbox.transport.io.send('readNotify', {
                                nid: data.id
                            });
                        }
                    });

                    data.soundPlay && Sandbox.sound.play('_message', 0.8);
                },

                renderMenu: function()
                {
                    var user = this.model.get('users').getMe();

                    if (user.get('groupId') == 3) return;

                    var compiledTemplate = _.template(
                        templateMenu,
                        {
                            model: this.model.toJSON(),
                            user: user,
                            Helper: Helper
                        }
                    );
                    $('#pun-ulinks ul li.item5').after(compiledTemplate);
                },

                prepareTopicViewers: function() {
                    if (!this.topicInitialValues.topicIsOpen) {
                        return;
                    }
                    var match = $('#topic-users-in .container').html().match(/\((\W+): (\d), (\W+): (\d)\)*/);
                    if (!match) {
                        return;
                    }
                    var users = [];
                    var usersEl = $('#topic-users-in .container a');
                    for (var i = 0; i < usersEl.length; i++) {
                        var el = $(usersEl[i]);
                        users.push({
                            id: el.attr('href').split('=')[1],
                            username: el.html()
                        });
                    }
                    this.topicInitialValues.guestTitle = match[1];
                    this.topicInitialValues.usersTitle = match[3];
                    this.topicInitialValues.guestsCount = +match[2];
                    this.topicInitialValues.usersCount = +match[1];
                    this.topicInitialValues.users = users;
                },

                renderTopicViewers: function() {
                    var compiledTemplate = _.template(
                        topicViewersContent,
                        {
                            model: this.model.toJSON(),
                            guestsCount: this.topicInitialValues.guestsCount,
                            usersCount: this.topicInitialValues.usersCount,
                            Helper: Helper,
                            title: $('#topic-users-in span:first').html(),
                            guestTitle: this.topicInitialValues.guestTitle,
                            usersTitle: this.topicInitialValues.usersTitle,
                            users: _.sortBy(this.topicInitialValues.users, 'username')
                        }
                    );
                    $('#topic-users-in').html(compiledTemplate);
                },

                updateCount: function(count)
                {
                    var elem = $('#pun-ulinks ul').find('.item8');

                    if (elem) {
                        elem.find('.bubble').html(count);
                        if (count > 0) {
                            elem.find('.bubble').show();
                        }
                        else {
                            elem.find('.bubble').hide();
                        }
                    }
                    this.favicon && this.favicon.badge(count);
                    // this.blinkTitle(count);
                },

                readNotice: function(e)
                {
                    var elem = $(e.currentTarget);
                    var nid = elem.attr('data-nid');

                    if (nid)
                        Sandbox.transport.io.send('readNotify', {
                            nid: nid
                        });
                },

                requestNotifications: function()
                {
                    this.isActive = true;
                    var user = this.model.get('users').getMe();
                    if (user.get('id') != Helper.getParam('id')) return;

                    var profileHtml = $('#profile8').html();
                    $('#profile').html('<div class="container">'+profileHtml+'</div>');
                    $('#profile .container fieldset, #profile .container p').remove('');
                    $("#profile .container").append('<div id="profileContainer"></div>');

                    this.renderContent();
                    Sandbox.transport.io.send('getNotifications');

                    setTimeout(function(){
                        Sandbox.transport.io.send('readAllNotifications');
                    }, 1000);
                },

                renderContent: function()
                {
                    var user = this.model.get('users').getMe();
                    var compiledTemplate = _.template(
                        templateContent,
                        {
                            model: this.model.toJSON(),
                            user: user,
                            items: this.items,
                            settings: this.settings,
                            Helper: Helper,
                            Config: Config
                        }
                    );
                    $('#profileContainer').html(compiledTemplate);
                },

                profileMenu: function()
                {
                    var user = this.model.get('users').getMe();

                    if (user.get('id') != Helper.getParam('id')) return;

                    var compiledTemplate = _.template(
                        templateProfileMenu,
                        {
                            model: this.model.toJSON(),
                            user: user,
                            Helper: Helper,
                            isActive: this.isActive
                        }
                    );
	                if (this.isActive) {
		                $('#profilenav ul li.isactive').removeClass('isactive');
	                }
                    $('#profilenav ul').append(compiledTemplate);
                },

                updateSettings: function(e)
                {
                    Sandbox.transport.io.send('updateNotificationSettings', {
                        notificate_about_mention: $('#fldNotify1').is(':checked') ? 1 : 0,
                        notificate_about_pm: $('#fldNotify2').is(':checked') ? 1 : 0,
                        notificate_about_award: $('#fldNotify3').is(':checked') ? 1 : 0,
                        notificate_about_reputation: $('#fldNotify4').is(':checked') ? 1 : 0,
                        notificate_about_report: $('#fldNotify5').is(':checked') ? 1 : 0,
                        notificate_about_gift: $('#fldNotify6').is(':checked') ? 1 : 0,
                        notification_sound: $('#fldNotify7').is(':checked') ? 1 : 0
                    });
                },

                closeMessage: function(e)
                {
                    var elem = $(e.currentTarget).parent();
                    var pid = elem.attr('data-id');

                    Sandbox.transport.io.send('readNotify', {
                        nid: pid
                    });
                },

                closeMessages: function(e)
                {
                    var elem = $(e.currentTarget).parent();
                    var pid = elem.attr('data-id');

                    $('.notify-message').each(function(i){
                        var pid = $(this).attr('data-id');
                        pid && Sandbox.transport.io.send('readNotify', {
                            nid: pid
                        });
                    });
                },

                blinkTitle: function(count)
                {
                    clearInterval(this.interval);
                    if (count == 0) {
                        document.title = this.pageTitle;
                        return;
                    }
                    var switcher = true,
                        _this = this;

                    this.interval = setInterval(function(){
                        if (switcher) {
                            document.title = count + Helper.declOfNum(count, [' новое уведомление', ' новых уведомления', ' новых уведомлений']);
                        }
                        else {
                            document.title = _this.pageTitle;
                        }
                        switcher = !switcher;
                    }, 1000);
                }
            });

        return {
            initialize: function(model)
            {
                if (Config.modules.notifications.enabled) {
                    return new NotificationsView({
                        el: $("body"),
                        model: model
                    })
                }
            }
        }
    }
);

